<template>
  <!-- TODO Preklady -->
  <div
    v-if="isCreated"
    v-cloak
    id="v-categories"
    ref="root"
    class="c-custom-bundle__categories"
  >
    <div class="c-custom-bundle__categories__title">Podlaha</div>

    <div v-if="selectedCategoryId" class="c-custom-bundle__categories__back">
      <button
        v-if="showBackButton"
        class="c-btn c-btn--primary"
        :title="backButtonName"
        @click.prevent="back"
      >
        <i class="ico ico-chevron-left is-on-left"></i>&nbsp;{{
          backButtonName
        }}
      </button>
    </div>

    <div class="c-custom-bundle__categories__categories">
      <a
        v-for="category in categories"
        :key="category.id"
        :href="category.link"
        :title="category.menu_name ? category.menu_name : category.name"
        class="c-custom-bundle__category-item"
        :class="{
          'is-active': category.id == selectedCategoryId,
        }"
        @click.prevent="change(category.id)"
      >
        <span class="c-custom-bundle__category-item__title">
          {{ category.menu_name ? category.menu_name : category.name }}
        </span>

        <span class="c-custom-bundle__category-item__count">
          {{ category.products_count }}
        </span>
      </a>
    </div>
  </div>
</template>

<script>
import CategoriesFilter from "FrontendComponents/CategoriesFilter/index.vue";
import client from "./../../../vendor/rshop/frontend/assets/js/common/client";

import { getCurrentStepBuilderState } from "../pages/bundleBuilder";

export default {
  extends: CategoriesFilter,
  computed: {
    backButtonName() {
      if (!this.selectedCategory) {
        return "";
      }

      if (this.actualView == "siblings" && this.parent) {
        return this.parent.name;
      }

      return this.selectedCategory.name;
    },
  },
  methods: {
    fetchCategories() {
      const bundleStepState = getCurrentStepBuilderState();

      let data = {
        select: this.forceSiblingsView ? 'siblings' : 'children',
      };

      if (this.selectedCategoryId) {
        data.category_id = this.selectedCategoryId;
      }

      if (this.productsCategories.length) {
        data.products_categories = this.productsCategories;
      }

      if (bundleStepState) {
        data.productTypeId = bundleStepState.productId;
      }

      this.isLoading = true;
      return client
          .post('/catalog/get-categories-tree', data)
          .then((response) => {
            // selected category doesn't have any subcategories
            if (response.data.categories.length > 0) {
              this.categories = response.data.categories;
            }

            this.selectedCategory = response.data.selected_category;
            document.querySelector(this.filterSelector).dispatchEvent(
                new CustomEvent('category.updated', {
                  detail: {
                    category: response.data.selected_category,
                  },
                })
            );

            this.isLoading = false;
            this.forceSiblingsView = false;
            this.actualView = response.data.view;
            this.parent = response.data.parent
          });
    },
  },
};
</script>
